{
  "name": "terminal",
  "version": "1697.884.0",
  "engines": {
    "npm": "please-use-yarn"
  },
  "scripts": {
    "setup:docker": "scripts/setup_npm_in_docker.sh",
    "ng": "ng",
    "start": "ng serve",
    "start:local-alpha": "ng serve -c local-alpha",
    "start:quicksight": "ng serve -c quicksight",
    "start:local-alpha-no-ssl": "ng serve -c local-alpha --host localhost --no-ssl",
    "build": "ng build -c prod",
    "build:size": "ng build -c size",
    "build-canary": "ng build -c canary",
    "build-ode-canary": "sed -i.bak \"s/{{ENVIRONMENT}}/$ENVIRONMENT/g\" src/environments/environment.ode-canary.ts && ng build -c ode-canary",
    "clean": "git clean -xdf",
    "test": "ng test --coverage",
    "test:watch": "ng test --coverage --watch",
    "test:watchall": "ng test --coverage --watch-all",
    "test:inspect": "node --inspect-brk=0.0.0.0:6449 node_modules/@angular/cli/bin/ng test --run-in-band",
    "test:watch:inspect": "node --inspect-brk=0.0.0.0:6449 node_modules/@angular/cli/bin/ng test --watch-all --run-in-band",
    "lint": "ng lint",
    "lint:all": "yarn lint && yarn stylelint",
    "format:check": "npx prettier --check .",
    "preinstall": "npx only-allow yarn",
    "stylelint": "npx stylelint \"**/*.scss\"",
    "remove-sdk": "yarn remove @boldpenguin/sdk @boldpenguin/sdk-icons @boldpenguin/sdk-polyfill @boldpenguin/sdk-auth @boldpenguin/sdk-core @boldpenguin/sdk-redux @boldpenguin/sdk-requests @boldpenguin/sdk-types @boldpenguin/sdk-utility @boldpenguin/sdk-web-components",
    "link-sdk": "yarn link @boldpenguin/sdk @boldpenguin/sdk-auth @boldpenguin/sdk-core @boldpenguin/sdk-redux @boldpenguin/sdk-requests @boldpenguin/sdk-types @boldpenguin/sdk-utility @boldpenguin/sdk-web-components @boldpenguin/sdk-websockets",
    "unlink-sdk": "yarn unlink @boldpenguin/sdk @boldpenguin/sdk-icons @boldpenguin/sdk-polyfill @boldpenguin/sdk-auth @boldpenguin/sdk-core @boldpenguin/sdk-redux @boldpenguin/sdk-requests @boldpenguin/sdk-types @boldpenguin/sdk-utility @boldpenguin/sdk-web-components @boldpenguin/sdk-websockets",
    "upgrade-sdk-next": "yarn upgrade @boldpenguin/sdk-auth@next @boldpenguin/sdk-core@next @boldpenguin/sdk-redux@next @boldpenguin/sdk-requests@next @boldpenguin/sdk-types@next @boldpenguin/sdk-utility@next @boldpenguin/sdk-web-components@next",
    "upgrade-sdk": "yarn upgrade --pattern @boldpenguin/sdk",
    "upgrade-sdk-latest": "yarn upgrade --latest --pattern @boldpenguin/sdk",
    "link-emperor": "yarn link @boldpenguin/emperor-features @boldpenguin/emperor-form-fields @boldpenguin/emperor-icons @boldpenguin/emperor-presentational @boldpenguin/emperor-sdk-wrapper @boldpenguin/emperor-services @boldpenguin/emperor-styles",
    "unlink-emperor": "yarn unlink @boldpenguin/emperor-features @boldpenguin/emperor-form-fields @boldpenguin/emperor-icons @boldpenguin/emperor-presentational @boldpenguin/emperor-sdk-wrapper @boldpenguin/emperor-services @boldpenguin/emperor-styles",
    "upgrade-emperor": "yarn upgrade --pattern @boldpenguin/emperor",
    "upgrade-emperor-latest": "yarn upgrade --latest --pattern @boldpenguin/emperor",
    "prepare": "husky install",
    "use-local-bp-libs": "node scripts/use-local-bp-libs.js",
    "dev:emp-local": "node scripts/emp-local.js",
    "dev:sdk-local": "node scripts/sdk-local.js"
  },
  "private": true,
  "resolutions": {
    "@typescript-eslint/utils": "^8.0.0",
    "@typescript-eslint/types": "^8.0.0",
    "typescript-eslint": "^8.0.0",
    "@babel/helper-compilation-targets": "7.22.15"
  },
  "dependencies": {
    "@angular/animations": "20.3.10",
    "@angular/cdk": "20.2.12",
    "@angular/common": "20.3.10",
    "@angular/compiler": "20.3.10",
    "@angular/core": "20.3.10",
    "@angular/elements": "20.3.10",
    "@angular/forms": "20.3.10",
    "@angular/material": "20.2.12",
    "@angular/platform-browser": "20.3.10",
    "@angular/platform-browser-dynamic": "20.3.10",
    "@angular/router": "20.3.10",
    "@angular/service-worker": "20.3.10",
    "@boldpenguin/emperor-features": "8.47.0",
    "@boldpenguin/emperor-form-fields": "8.47.0",
    "@boldpenguin/emperor-icons": "8.47.0",
    "@boldpenguin/emperor-presentational": "8.47.0",
    "@boldpenguin/emperor-sdk-wrapper": "8.47.0",
    "@boldpenguin/emperor-services": "8.47.0",
    "@boldpenguin/emperor-styles": "8.47.0",
    "@boldpenguin/sdk": "15.1.0-internal-20260519143511",
    "@ng-icons/core": "^32.1.0",
    "@ng-icons/material-icons": "^32.1.0",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/entity": "^20.1.0",
    "@ngrx/operators": "^20.1.0",
    "@ngrx/router-store": "^20.1.0",
    "@ngrx/schematics": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@ngrx/store-devtools": "^20.1.0",
    "@pdftron/webviewer": "11.10.0",
    "@rails/activestorage": "^8.1.200",
    "@sentry/angular": "^10.48.0",
    "@stripe/stripe-js": "^5.4.0",
    "@types/google.maps": "^3.58.1",
    "amazon-quicksight-embedding-sdk": "2.2.2",
    "angular-animations": "^0.11.0",
    "angular-imask": "7.1.3",
    "chart.js": "^4.5.0",
    "core-js": "^3.27.2",
    "date-fns": "^2.29.3",
    "eslint-plugin-rxjs-angular": "^2.0.1",
    "file-saver": "^2.0.5",
    "filesize": "9.0.11",
    "lodash": "^4.17.21",
    "logrocket": "^8.1.0",
    "logrocket-fuzzy-search-sanitizer": "0.0.2",
    "marked": "^15.0.0",
    "mixpanel-browser": "2.45.0",
    "ng2-charts": "^8.0.0",
    "ng2-pdf-viewer": "^9.1.3",
    "ngx-filesize": "^3.0.6",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-markdown": "^19.1.0",
    "ngx-sortablejs": "file:src/assets/scripts/ngx-sortablejs-13.0.0.tgz",
    "ngx-webstorage": "^20.0.0",
    "rxjs": "7.8.1",
    "sortablejs": "^1.15.0",
    "tslib": "^2.5.0",
    "zone.js": "0.15.1"
  },
  "lint-staged": {
    "*.scss": "stylelint --fix",
    "*": "prettier --write"
  },
  "devDependencies": {
    "@angular-builders/jest": "^20.0.0",
    "@angular-eslint/builder": "^20.6.0",
    "@angular-eslint/eslint-plugin": "^20.6.0",
    "@angular-eslint/eslint-plugin-template": "^20.6.0",
    "@angular-eslint/schematics": "^20.6.0",
    "@angular-eslint/template-parser": "^20.6.0",
    "@angular/build": "^20.3.9",
    "@angular/cli": "20.3.9",
    "@angular/compiler-cli": "20.3.10",
    "@angular/language-service": "20.3.10",
    "@faker-js/faker": "^7.6.0",
    "@jackfranklin/test-data-bot": "^2.1.0",
    "@ngrx/eslint-plugin": "^20.0.1",
    "@semantic-release/commit-analyzer": "^9.0.2",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^8.0.6",
    "@semantic-release/npm": "^9.0.1",
    "@semantic-release/release-notes-generator": "^10.0.3",
    "@types/file-saver": "^2.0.5",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.14.191",
    "@types/mixpanel-browser": "^2.38.0",
    "@types/node": "20.17.6",
    "@types/rails__activestorage": "^8.0.1",
    "@types/sortablejs": "^1.15.0",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "conventional-changelog-conventionalcommits": "^5.0.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "10.1.5",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-jest-formatting": "^3.1.0",
    "eslint-plugin-jsdoc": "50.4.3",
    "eslint-plugin-prefer-arrow": "^1.2.2",
    "eslint-plugin-rxjs": "^5.0.3",
    "husky": "^8.0.3",
    "jasmine-marbles": "^0.9.2",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.6.0",
    "jest-slow-test-reporter": "^1.0.0",
    "lint-staged": "^13.2.2",
    "ng-mocks": "^14.13.5",
    "only-allow": "^1.1.1",
    "postcss": "^8.4.31",
    "postcss-scss": "^4.0.3",
    "prettier": "^3.5.3",
    "semantic-release": "^19.0.5",
    "stylelint": "16.10.0",
    "stylelint-config-recommended-scss": "14.1.0",
    "stylelint-prettier": "5.0.3",
    "stylelint-scss": "6.8.1",
    "ts-jest": "^29.0.5",
    "typescript": "5.9.3"
  },
  "packageManager": "yarn@4.12.0"
}
